import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  approvalRequired: false,
};

const privacySlice = createSlice({
  name: "privacy",
  initialState,
  reducers: {
    requirePrivacyApproval: (state) => {
      if (!state.approvalRequired) {
        state.approvalRequired = true;
      }
    },
    resetPrivacyApproval: (state) => {
      if (state.approvalRequired) {
        state.approvalRequired = false;
      }
    },
  },
});

export const {requirePrivacyApproval, resetPrivacyApproval} = privacySlice.actions;

export default privacySlice.reducer;
